import { BiEditAlt } from "react-icons/bi"; 
import React, { useState, useEffect } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

const BoardPostsManagement = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showPostModal, setShowPostModal] = useState(false);
  const [searchUserId, setSearchUserId] = useState('');
  const [newPost, setNewPost] = useState({
    title: '',
    content: ''
  });
  const [expandedPosts, setExpandedPosts] = useState(new Set());

  useEffect(() => {
    fetchAllPosts();
  }, []);

  const fetchAllPosts = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API_URL}/api/board/`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      // The API returns {posts, pagination}, so we need to extract posts
      setPosts(response.data.posts || response.data);
    } catch (error) {
      console.error('Error fetching posts:', error);
      // Fallback to mock data if API fails
      const mockPosts = [
        {
          _id: '1',
          userID: {
            _id: '1',
            name: '田中 花子',
            userID: '12345678',
            email: 'tanaka@example.com'
          },
          title: 'システムメンテナンスのお知らせ',
          content: '来週月曜日の午前2時から4時までシステムメンテナンスを実施いたします。ご不便をおかけしますが、ご理解いただけますようお願いいたします。',
          created_at: '2024-01-15T14:30:00.000Z',
          readerCount: 45,
          likes: [],
          dislikes: []
        },
        {
          _id: '2',
          userID: {
            _id: '2',
            name: '佐藤 太郎',
            userID: '87654321',
            email: 'sato@example.com'
          },
          title: '新機能リリースのお知らせ',
          content: 'マッチング精度を向上させる新機能がリリースされました。より良い出会いを見つけるために、ぜひご利用ください。',
          created_at: '2024-01-14T09:15:00.000Z',
          readerCount: 32,
          likes: [],
          dislikes: []
        }
      ];
      setPosts(mockPosts);
    } finally {
      setLoading(false);
    }
  };

  const searchByUserId = async () => {
    if (!searchUserId.trim()) {
      fetchAllPosts();
      return;
    }

    try {
      setLoading(true);
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API_URL}/api/board/${searchUserId}`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      // Handle both array and object responses
      const postsData = Array.isArray(response.data) ? response.data : (response.data.posts || []);
      setPosts(postsData);
    } catch (error) {
      console.error('Error searching posts:', error);
      setPosts([]);
    } finally {
      setLoading(false);
    }
  };

  const handleCreatePost = async () => {
    try {
      const token = localStorage.getItem('token');
      console.log("token------------------", token);
      await axios.post(`${API_URL}/api/board`, newPost, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      // Refresh posts
      await fetchAllPosts();
      
      setShowPostModal(false);
      setNewPost({ title: '', content: '' });
    } catch (error) {
      console.error('Error creating post:', error);
    }
  };

  const togglePostExpansion = (postId) => {
    const newExpandedPosts = new Set(expandedPosts);
    if (newExpandedPosts.has(postId)) {
      newExpandedPosts.delete(postId);
    } else {
      newExpandedPosts.add(postId);
    }
    setExpandedPosts(newExpandedPosts);
  };

  // Calculate statistics
  const totalPosts = Array.isArray(posts) ? posts.length : 0;
  const totalReaders = Array.isArray(posts) ? posts.reduce((sum, post) => sum + (post.readerCount || 0), 0) : 0;
  const totalLikes = Array.isArray(posts) ? posts.reduce((sum, post) => sum + (post.likes?.length || 0), 0) : 0;
  const totalDislikes = Array.isArray(posts) ? posts.reduce((sum, post) => sum + (post.dislikes?.length || 0), 0) : 0;

  if (loading) {
    return (
      <div style={{ textAlign: 'center', padding: '50px' }}>
        <div>読み込み中...</div>
      </div>
    );
  }

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '30px' }}>
        <h2 style={{ color: '#2c3e50', margin: 0 }}>掲示板管理</h2>
        <button
          onClick={() => setShowPostModal(true)}
          style={{
            backgroundColor: '#27ae60',
            color: 'white',
            border: 'none',
            padding: '12px 24px',
            borderRadius: '5px',
            cursor: 'pointer',
            fontSize: '14px',
            fontWeight: 'bold'
          }}
        >
          <BiEditAlt /> 新規投稿
        </button>
      </div>

      {/* Statistics Cards */}
      <div style={{ marginBottom: '20px' }}>
        <div style={{ display: 'flex', gap: '20px', marginBottom: '20px' }}>
          <div style={{
            backgroundColor: '#3498db',
            color: 'white',
            padding: '15px',
            borderRadius: '8px',
            flex: 1,
            textAlign: 'center'
          }}>
            <div style={{ fontSize: '24px', fontWeight: 'bold' }}>
              {totalPosts}
            </div>
            <div style={{ fontSize: '14px' }}>総投稿数</div>
          </div>
          <div style={{
            backgroundColor: '#e67e22',
            color: 'white',
            padding: '15px',
            borderRadius: '8px',
            flex: 1,
            textAlign: 'center'
          }}>
            <div style={{ fontSize: '24px', fontWeight: 'bold' }}>
              {totalReaders}
            </div>
            <div style={{ fontSize: '14px' }}>総閲覧数</div>
          </div>
          <div style={{
            backgroundColor: '#27ae60',
            color: 'white',
            padding: '15px',
            borderRadius: '8px',
            flex: 1,
            textAlign: 'center'
          }}>
            <div style={{ fontSize: '24px', fontWeight: 'bold' }}>
              {totalLikes}
            </div>
            <div style={{ fontSize: '14px' }}>総いいね数</div>
          </div>
          <div style={{
            backgroundColor: '#e74c3c',
            color: 'white',
            padding: '15px',
            borderRadius: '8px',
            flex: 1,
            textAlign: 'center'
          }}>
            <div style={{ fontSize: '24px', fontWeight: 'bold' }}>
              {totalDislikes}
            </div>
            <div style={{ fontSize: '14px' }}>総よくないね数</div>
          </div>
        </div>
      </div>

      {/* Search Section */}
      <div style={{ 
        backgroundColor: '#f8f9fa', 
        padding: '20px', 
        borderRadius: '8px', 
        marginBottom: '30px' 
      }}>
        <h3 style={{ marginBottom: '15px', color: '#2c3e50' }}>ユーザーID検索</h3>
        <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
          <input
            type="text"
            value={searchUserId}
            onChange={(e) => setSearchUserId(e.target.value)}
            placeholder="ユーザーIDを入力..."
            style={{
              padding: '10px',
              border: '1px solid #ddd',
              borderRadius: '5px',
              flex: 1,
              maxWidth: '300px'
            }}
          />
          <button
            onClick={searchByUserId}
            style={{
              backgroundColor: '#3498db',
              color: 'white',
              border: 'none',
              padding: '10px 20px',
              borderRadius: '5px',
              cursor: 'pointer'
            }}
          >
            検索
          </button>
          <button
            onClick={() => {
              setSearchUserId('');
              fetchAllPosts();
            }}
            style={{
              backgroundColor: '#95a5a6',
              color: 'white',
              border: 'none',
              padding: '10px 20px',
              borderRadius: '5px',
              cursor: 'pointer'
            }}
          >
            クリア
          </button>
        </div>
      </div>

      {/* Posts List */}
      <div style={{ display: 'grid', gap: '20px' }}>
        {Array.isArray(posts) && posts.length > 0 ? (
          posts.map((post) => (
            <div
              key={post._id}
              style={{
                backgroundColor: 'white',
                borderRadius: '8px',
                padding: '20px',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                border: '1px solid #ecf0f1'
              }}
            >
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '15px' }}>
                <div>
                  <h3 style={{ margin: '0 0 5px 0', color: '#2c3e50' }}>{post.title}</h3>
                  <div style={{ display: 'flex', gap: '15px', alignItems: 'center' }}>
                    <span style={{ color: '#7f8c8d', fontSize: '14px' }}>
                      投稿日時: {new Date(post.created_at).toLocaleString('ja-JP')}
                    </span>
                    <span style={{
                      backgroundColor: '#3498db',
                      color: 'white',
                      padding: '2px 8px',
                      borderRadius: '10px',
                      fontSize: '12px'
                    }}>
                      {post.userID?.name}
                    </span>
                  </div>
                </div>
              </div>
              
              <div style={{
                backgroundColor: '#f8f9fa',
                padding: '15px',
                borderRadius: '5px',
                marginBottom: '15px',
                borderLeft: '4px solid #3498db'
              }}>
                <div style={{
                  margin: 0,
                  lineHeight: '1.6',
                  color: '#2c3e50',
                  whiteSpace: 'pre-wrap',
                  wordBreak: 'break-word',
                  overflowWrap: 'break-word',
                  maxHeight: expandedPosts.has(post._id) ? 'none' : '50px',
                  overflow: expandedPosts.has(post._id) ? 'visible' : 'hidden',
                  position: 'relative'
                }}>
                  {post.content}
                  {!expandedPosts.has(post._id) && post.content && post.content.length > 100 && (
                    <div style={{
                      position: 'absolute',
                      bottom: '0',
                      right: '0',
                      background: 'linear-gradient(transparent, #f8f9fa)',
                      height: '50px',
                      width: '100%',
                      pointerEvents: 'none'
                    }}></div>
                  )}
                </div>
                {post.content && post.content.length > 100 && (
                  <div 
                    onClick={() => togglePostExpansion(post._id)}
                    style={{
                      fontSize: '12px',
                      color: '#3498db',
                      marginTop: '5px',
                      cursor: 'pointer',
                      fontWeight: 'bold'
                    }}
                  >
                    {expandedPosts.has(post._id) ? '▲ 折りたたむ' : '▼ 全文を表示'}
                  </div>
                )}
              </div>
              
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '15px' }}>
                <div style={{ textAlign: 'center' }}>
                  <div style={{ fontSize: '18px', fontWeight: 'bold', color: '#2c3e50' }}>
                    {post.userID?.userID || 'N/A'}
                  </div>
                  <div style={{ fontSize: '12px', color: '#7f8c8d' }}>ユーザーID</div>
                </div>
                <div style={{ textAlign: 'center' }}>
                  <div style={{ fontSize: '18px', fontWeight: 'bold', color: '#e67e22' }}>
                    {post.readerCount || 0}
                  </div>
                  <div style={{ fontSize: '12px', color: '#7f8c8d' }}>閲覧数</div>
                </div>
                <div style={{ textAlign: 'center' }}>
                  <div style={{ fontSize: '18px', fontWeight: 'bold', color: '#27ae60' }}>
                    {post.likes?.length || 0}
                  </div>
                  <div style={{ fontSize: '12px', color: '#7f8c8d' }}>いいね</div>
                </div>
                <div style={{ textAlign: 'center' }}>
                  <div style={{ fontSize: '18px', fontWeight: 'bold', color: '#e74c3c' }}>
                    {post.dislikes?.length || 0}
                  </div>
                  <div style={{ fontSize: '12px', color: '#7f8c8d' }}>よくないね</div>
                </div>
              </div>
            </div>
          ))
        ) : (
          <div style={{
            backgroundColor: 'white',
            borderRadius: '8px',
            padding: '40px',
            textAlign: 'center',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
            border: '1px solid #ecf0f1'
          }}>
            <p style={{ color: '#7f8c8d', fontSize: '16px', margin: 0 }}>
              {Array.isArray(posts) ? '投稿がありません' : '投稿データの読み込み中...'}
            </p>
          </div>
        )}
      </div>

      {/* Create Post Modal */}
      {showPostModal && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.5)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 1000
        }}>
          <div style={{
            backgroundColor: 'white',
            padding: '30px',
            borderRadius: '10px',
            width: '600px',
            maxWidth: '90%',
            maxHeight: '80vh',
            overflow: 'auto'
          }}>
            <h3 style={{ marginBottom: '20px' }}>新規掲示板投稿</h3>
            
            <div style={{ marginBottom: '20px' }}>
              <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
                タイトル:
              </label>
              <input
                type="text"
                value={newPost.title}
                onChange={(e) => setNewPost({...newPost, title: e.target.value})}
                placeholder="投稿タイトルを入力..."
                style={{
                  width: '100%',
                  padding: '10px',
                  border: '1px solid #ddd',
                  borderRadius: '5px'
                }}
              />
            </div>
            
            <div style={{ marginBottom: '20px' }}>
              <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
                内容:
              </label>
              <textarea
                value={newPost.content}
                onChange={(e) => setNewPost({...newPost, content: e.target.value})}
                placeholder="投稿内容を入力..."
                style={{
                  width: '100%',
                  height: '200px',
                  padding: '12px',
                  border: '1px solid #ddd',
                  borderRadius: '5px',
                  resize: 'vertical'
                }}
              />
            </div>
            
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
              <button
                onClick={() => setShowPostModal(false)}
                style={{
                  backgroundColor: '#95a5a6',
                  color: 'white',
                  border: 'none',
                  padding: '10px 20px',
                  borderRadius: '5px',
                  cursor: 'pointer'
                }}
              >
                キャンセル
              </button>
              <button
                onClick={handleCreatePost}
                disabled={!newPost.title.trim() || !newPost.content.trim()}
                style={{
                  backgroundColor: (!newPost.title.trim() || !newPost.content.trim()) ? '#95a5a6' : '#27ae60',
                  color: 'white',
                  border: 'none',
                  padding: '10px 20px',
                  borderRadius: '5px',
                  cursor: (!newPost.title.trim() || !newPost.content.trim()) ? 'not-allowed' : 'pointer'
                }}
              >
                投稿する
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default BoardPostsManagement; 